module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAABoaGhvb29oaGhoaGhqampnZ2dnZ2dqamp6enpnZ2dnZ2dnZ2doaGhpaWlnZ2dpaWkkcn76AAAAEXRSTlMAgBZZRyddbh8Lemh0UD0+MzcjiL8AAAEPSURBVFjD7ZbdrgMhCIQdBV3d3bbv/7SnJiY96R/a2fbK76oNhDAsAm4ymUy+ySJx3cq2RlmYKKHgRgkfxvIB9wTvxhFUkqjPLnuVhIqMhskRV3b/P8MdV2Iek5WakEexaURernFOTwynGmkgpwgUfWrRAsShOusLmw5U3N90vVDXWaYABNtsswDwRsJLZ0L7W4e9M6UCeKuGpU9ZMlxSlzYBhHZpzaiGi3Y15Qp4u9FWO9AGZOspApsdCECHT/lhRnyN+K/G9xHf2fxb+9nr5+cRPyH5mc1vEX6vHb1p+d2vZz3kGqnhwgH3kaIS+Yvt3H7TN6S2/0pftQFNJU1E5eJ4AtqwpVG5uMlkMjmYP8KuBtlzhGHhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/search.png
// module id = 129
// module chunks = 40